(function () {
  angular
    .module('kareo.ui.shared.modules.billingWorkflow', [
      'kareo.ui.shared.modules.featureSet',
      'kareo.ui.shared.modules.data'])
    .factory('billingWorkflowService', billingWorkflowService);

  billingWorkflowService.$inject = ['$http', 'featureSet', 'activeCustomerProducts', 'practice'];

  function billingWorkflowService($http, featureSet, activeCustomerProducts, practice) {
    // load feature set
    featureSet.load();

    // get customer products
    var isKmbCustomer;
    activeCustomerProducts.get().then((data) => {
      isKmbCustomer = !!data.RCM;
    }
    );

    // check for pm
    var pmEnabled;
    practice.get().then((results) => {
      pmEnabled = results.pmenabled;
    });

    var stepsUrl = {
      tasks: '/billing-tasks-ui/#/tasks/list',
      charges: '/charge-capture-ui/#/charge-capture/charges',
      claims: '/claim-tracking-ui/#/claim-view',
      balances: '/patient-collections-ui/#/patient-statements/list'
    };
    var billingTasksURL = '/billing-tasks-ui/api/shared/TotalCount';

    var serviceObj = {};
    serviceObj.getBillingTasksCount = getBillingTasksCount;
    serviceObj.getURLFor = getURLFor;
    serviceObj.stepEnabled = stepEnabled;
    serviceObj.getEntryPointUrlForBilling = getEntryPointUrlForBilling;

    return serviceObj;

    function getBillingTasksCount() {
      return $http.get(billingTasksURL).then((response) => {
        return response.data;
      });
    }

    function getURLFor(stepName) {
      return stepsUrl[stepName];
    }

    function stepEnabled(stepName) {
      var enabled = false;
      switch (stepName) {
        case 'tasks':
          enabled = isBillingTasksEnabled();
          break;
        case 'charges':
          enabled = isChargesEnabled();
          break;
        case 'claims':
          enabled = true;
          break;
        case 'balances':
          enabled = isPatientBalancesEnabled();
          break;
        default:
          enabled = false;
      }
      return enabled;
    }

    function getEntryPointUrlForBilling() {
      var entryPointStep;
      if (stepEnabled('tasks')) {
        entryPointStep = 'tasks';
      } else if (stepEnabled('charges')) {
        entryPointStep = 'charges';
      } else if (stepEnabled('claims')) {
        entryPointStep = 'claims';
      } else if (stepEnabled('balances')) {
        entryPointStep = 'balances';
      }
      return getURLFor(entryPointStep) + '?view=billing-workflow';
    }

    function isBillingTasksEnabled() {
      return featureSet.features()['dark-feature.kmb-billing-tasks'] && isKmbCustomer;
    }

    function isChargesEnabled() {
      return ((featureSet.features()['dark-feature.kmb-charge-capture'] && !featureSet.hasClinicalFeatures()) || (featureSet.hasClinicalFeatures() && featureSet.features()['dark-feature.kmb-charge-capture-ehr-active'])) && pmEnabled;
    }

    function isPatientBalancesEnabled() {
      return featureSet.features()['dark-feature.converged-patient-collections'] && pmEnabled;
    }
  }
})();
